import React from 'react'
import { jt, t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Form } from 'components/shared/Form/Form'
import { Modal } from 'components/shared/Modal/Modal'

import { PROJECT_TITLE_FIELD } from './model'
import { PROJECT_TITLE_FIELD_LIMIT } from './schema'

import styles from './JobNameAssignmentModal.module.scss'

export const JobNameAssignmentModal = ({
  form: { control, formState, watch },
  template,
  onBack,
  onCancel,
  onClose,
  onConfirm,
  onConfirmationCancel,
  onConfirmationClose,
  onConfirmationConfirm,
  isConfirmationOpen,
  isOpen,
}) => {
  const message = (
    <span className={styles.bold} key="template">
      {template?.name}
    </span>
  )

  return (
    <>
      <Modal
        className={styles.modal}
        backLabel={onBack ? t`Back` : null}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        title={t`Create job from template`}
        {...{ onBack, onCancel, onClose, onConfirm, isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <MessageAlert
            className={styles.alert}
            message={jt`You will create a new job based on ${message} template.`}
            variant="info"
            isInitialised
          />
          <Form onSubmit={onConfirm}>
            <Form.Field
              count={watch(PROJECT_TITLE_FIELD)?.length}
              error={formState.errors[PROJECT_TITLE_FIELD]?.message}
              field="input"
              label={t`Title`}
              limit={PROJECT_TITLE_FIELD_LIMIT}
              name={PROJECT_TITLE_FIELD}
              {...{ control }}
            />
          </Form>
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={onConfirmationCancel}
        onClose={onConfirmationClose}
        onConfirm={onConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
